document.addEventListener("turbolinks:load", function() {
  delete window.__axeptioSDK;
})